import React, { useState, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { validaSoloNumero } from "../../util/varios";
import CatalogoBaseDatos from "../../catalogos/catalogoBaseDatos";

const GestionarBaseDatos = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnCatalogo = useRef();
  const txtCodBase = useRef();
  const txtBaseDatos = useRef();
  const txtIp = useRef();
  const txtPuerto = useRef();
  const cmbPlantilla = useRef();

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [catalogo, setCatalogo] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
    tab1: false,
    tab2: true,
  });

  const blanquear = () => {
    if (botones.incluir) {
      txtCodBase.current.value = "";
    }

    txtBaseDatos.current.value = "";
    txtIp.current.value = "";
    txtPuerto.current.value = "";

    setActivate(false);
    setBody(null);
    setHabilitado(true);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setVisibleBtn("visible");
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
      tab1: false,
      tab2: true,
    });
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtBaseDatos.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Ingrese el nombre de la base de datos",
          icono: "informacion",
        });
        sigue = false;
        txtBaseDatos.current.focus();
      } else if (txtIp.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Ingrese la ip",
          icono: "informacion",
        });
        sigue = false;
        txtIp.current.focus();
      } else if (txtPuerto.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Ingrese el puerto",
          icono: "informacion",
        });
        sigue = false;
        txtPuerto.current.focus();
      }
    }

    if (sigue) {
      var base = [
        {
          idbasedatos: !botones.incluir ? 0 : txtCodBase.current.value,
          nombre: txtBaseDatos.current.value.trim(),
          ip: txtIp.current.value.trim(),
          puerto: parseInt(txtPuerto.current.value),
        },
      ];

      setBody({
        base,
        plantilla:
          botones.incluir === false ? cmbPlantilla.current.value.trim() : "",
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/athos/base/actualizar/${ope}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "nombre_basedatos_ukey"'
          ) {
            mensaje = "Ya existe una base de datos Con ese nombre";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const seleccionarRegistro = (id) => {
    let campos = "idbasedatos, trim(nombre) as nombre, trim(ip) as ip, puerto";
    let nomtab = "basedatos";
    let nomid = "idbasedatos";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtBaseDatos.current.value = response.data.nombre;
          txtIp.current.value = response.data.ip;
          txtPuerto.current.value = response.data.puerto;
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      seleccionarRegistro(txtCodBase.current.value);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "nombre" || e.target.name === "ip") {
      e.target.value = e.target.value.trim();
      e.target.value = e.target.value.toLowerCase();
    }
  };

  const onCatalogoBaseDatos = (values) => {
    setCatalogo(false);

    txtCodBase.current.value = values.idbasedatos;
    seleccionarRegistro(values.idbasedatos);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op !== 6) {
      setVisibleBtn("hidden");
    } else {
      setVisibleBtn("visible");
    }

    if (op === 1) {
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoper: false,
        tab1: true,
        tab2: true,
      });
      txtBaseDatos.current.focus();
    } else if (op === 2) {
      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
        tab1: false,
        tab2: false,
      });
      btnCatalogo.current.focus();
    } else if (op === 3) {
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
        tab1: false,
        tab2: false,
      });
      btnCatalogo.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
        tab1: false,
        tab2: false,
      });

      btnCatalogo.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="col-md-12 mx-auto row">
        <div className="col-md-12 py-2 row card">
          <div className="col-md-12 mx-auto rounded py-2  border-azul ">
            <div className=" row rounded px-0 d-flex justify-content-between">
              {botones.tab1 === true && (
                <div className="input-group mb-2 input-group-sm col-sm-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Plantilla
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example col-md-4"
                    name="plantilla"
                    disabled={habilitado}
                    ref={cmbPlantilla}
                  >
                    <option value={"plantilla"}>POLAR</option>
                    <option value={"plantilla"}>TIENDA</option>
                    <option value={"plantilla"}>FERRETERIA</option>
                  </select>
                </div>
              )}

              {botones.tab1 === false && (
                <div className="input-group input-group-sm mb-2 col-md-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    ref={txtCodBase}
                    disabled
                    onKeyUp={validarCodigo}
                    onBlur={validarCodigo}
                    name="idubicacion"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <button
                    disabled={botones.catalogo}
                    ref={btnCatalogo}
                    onClick={() => setCatalogo(true)}
                    type="button"
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              )}

              <div className="col-md-8 input-group input-group-sm mb-2">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Base de Datos:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtBaseDatos}
                  disabled={habilitado}
                  name="nombre"
                  placeholder="j123456789"
                  onChange={onChange}
                  className="form-control lowercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
              <div className="col-md-6 input-group input-group-sm mb-2">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Ip:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtIp}
                  disabled={habilitado}
                  name="ip"
                  placeholder="3.144.143.71"
                  onChange={onChange}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div className="col-md-6 input-group input-group-sm mb-2">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Puerto:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtPuerto}
                  disabled={habilitado}
                  placeholder="5432"
                  onChange={validaSoloNumero}
                  className="form-control text-right"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>

            <div className="col-md-12 mt-2 d-flex justify-content-end">
              {visibleBtn === "visible" ? (
                <div
                  className="col-md-12 d-flex justify-content-start"
                  style={{ visibility: visibleBtn }}
                >
                  <button
                    disabled={botones.incluir}
                    onClick={onBotones(1)}
                    className="btn btn-sm mx-1 btn-primary rounded-pill"
                    style={{ height: "27px" }}
                    title="Incluir Moneda"
                  >
                    <i style={{ fontSize: "9px" }} className="fas fa-plus">
                      {" "}
                      Incluir{" "}
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.consultar}
                    onClick={onBotones(4)}
                    className="btn btn-sm mx-1 btn-info rounded-pill"
                    style={{ height: "27px" }}
                    title="Consultar Moneda"
                  >
                    <i style={{ fontSize: "9px" }} className="fas fa-eye">
                      Consultar
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.modificar}
                    onClick={onBotones(2)}
                    className="btn btn-sm mx-1 btn-warning rounded-pill"
                    style={{ height: "27px" }}
                    title="Modificar Moneda"
                  >
                    <i style={{ fontSize: "9px" }} className="fa fa-edit">
                      Modificar
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.eliminar}
                    onClick={onBotones(3)}
                    className="btn btn-sm mx-1 btn-danger rounded-pill"
                    style={{ height: "27px" }}
                    title="Eliminar Moneda"
                  >
                    <i style={{ fontSize: "9px" }} className="fa fa-trash">
                      Eliminar
                    </i>{" "}
                  </button>
                </div>
              ) : (
                <div
                  className="col-md-5 d-flex justify-content-end"
                  style={{
                    visibility: visibleBtn === "visible" ? "hidden" : "visible",
                  }}
                >
                  <button
                    disabled={botones.aceptar}
                    onClick={onBotones(5)}
                    ref={btnAcepta}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-sm rounded-pill btn-success"
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Aceptar
                    </i>
                  </button>
                  <button
                    disabled={botones.cancelar}
                    onClick={onBotones(6)}
                    ref={btnCancela}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-danger btn-sm rounded-pill"
                  >
                    <i
                      className="fas fa-window-close"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Cancelar
                    </i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>

      <CatalogoBaseDatos
        show={catalogo}
        onHideCancelar={() => setCatalogo(false)}
        onHideAceptaCatalogo={onCatalogoBaseDatos}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default GestionarBaseDatos;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/gestionBaseDatos.js